import { render, staticRenderFns } from "./TipolugarModalEdicion.vue?vue&type=template&id=2a119dcb&scoped=true&"
import script from "./TipolugarModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./TipolugarModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./TipolugarModalEdicion.vue?vue&type=style&index=0&id=2a119dcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a119dcb",
  null
  
)

export default component.exports